import { render, staticRenderFns } from "./KioskDemo.vue?vue&type=template&id=34e66a06&scoped=true&lang=pug"
import script from "./KioskDemo.vue?vue&type=script&lang=js"
export * from "./KioskDemo.vue?vue&type=script&lang=js"
import style0 from "./KioskDemo.vue?vue&type=style&index=0&id=34e66a06&prod&lang=scss"
import style1 from "./KioskDemo.vue?vue&type=style&index=1&id=34e66a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e66a06",
  null
  
)

export default component.exports